/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');

const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');

require('./integral-records.scss');
const template = require('./integral-records.tpl');

const IntegralRecords = {
	name: "integral-records",

	template,

	data() {
		return {
			thItems: ["序号", "用户名", "性别", "手机号", "事件名称", "积分", "操作时间", "备注"],
			url: apiPath.user.queryIntegralRecords,
			integralName: [],
			sex: {
				"0": "未知",
				"1": "男",
				"2": "女"
			}
		}
	},

	ready() {
		this.queryIntegralName();
	},

	methods: {
		queryIntegralName() {
			let url = apiPath.user.queryIntegralName;
			this.integralName.push({
				text: '事件名称',
				value: -1
			});
			ajaxHttp(url).then((res) => {
				res.data.forEach((item, index) => {
					this.integralName.push({
						text: item.integralName,
						value: item.integralId
					})
				})
			}).catch((res) => {
				tip(res.error);
			})
		},
		qurryIntegralRecords() {
			let queryParams = {
				integralId: this.$refs.integralDropmenu.val(),
				keyType: this.$refs.ktypeDropmenu.val(),
        keyWord: this.$refs.kwordInputbox.val()
			};
			this.$refs.tableData.query(queryParams).fetch();
		}
	},

	filters: {
		changeSex(value) {
			return this.sex[value];
		}
	},

	store
}

module.exports = IntegralRecords;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/user/integral-records/integral-records.js